<template>
  <div class="p-4">
    <!-- Order Food -->
    <router-link class="relative block rounded-xl overflow-hidden" to="/report/1">
      <div class="transition-all transform "
           @touchstart="toggleAnimation($event)"
           @touchend="toggleAnimation">
        <img src="../assets/img/homepage/banner_returned_cheque.png" class="w-full">
      </div>
    </router-link>

    <div class="flex justify-between gap-4 mt-4">
      <!-- Notification Inbox  -->
      <router-link to="/report/2">
        <div class="rounded-xl overflow-hidden  transition-all transform"
             @touchstart="toggleAnimation($event)"
             @touchend="toggleAnimation">
          <img src="../assets/img/homepage/banner_hyper_markets_deposit.png" class="w-screen">
        </div>
      </router-link>

      <router-link to="/report/7">
        <div class="rounded-xl overflow-hidden  transition-all transform"
             @touchstart="toggleAnimation($event)"
             @touchend="toggleAnimation">
          <img src="../assets/img/homepage/banner_hyper_markets_remain.png" class="w-screen">
        </div>
      </router-link>

    </div>

    <!-- Management -->
    <router-link class="relative block rounded-xl overflow-hidden mt-4" to="/report/4">
      <div class="transition-all transform "
           @touchstart="toggleAnimation($event)"
           @touchend="toggleAnimation">
        <img src="../assets/img/homepage/banner_factors.png" class="w-full">
      </div>
    </router-link>

    <div class="flex justify-between gap-4 mt-4">
      <!-- Menu -->
      <router-link class="relative block rounded-xl overflow-hidden" to="/report/5">
        <div class="transition-all transform "
             @touchstart="toggleAnimation($event)"
             @touchend="toggleAnimation">
          <img src="../assets/img/homepage/banner_customer_remain.png">
        </div>
      </router-link>

      <!-- Cheque -->
      <router-link class="relative block rounded-xl overflow-hidden" to="/report/3">
        <div class="transition-all transform "
             @touchstart="toggleAnimation($event)"
             @touchend="toggleAnimation">
          <img src="../assets/img/homepage/banner_future_cheque.png">
        </div>
      </router-link>
    </div>
    <!--ReportChart-->
     <router-link class="relative block rounded-xl overflow-hidden mt-4" to="/ReportChart">
      <div class="transition-all transform "
           @touchstart="toggleAnimation($event)"
           @touchend="toggleAnimation">
        <img src="../assets/img/homepage/banner_report.png" class="w-full">
      </div>
    </router-link>
    <router-link class="relative block rounded-xl overflow-hidden mt-4" to="/HorekaReport">
      <div class="transition-all transform "
           @touchstart="toggleAnimation($event)"
           @touchend="toggleAnimation">
        <img src="../assets/img/homepage/banner_horekareport.png" class="w-full">
      </div>
    </router-link>

  </div>

</template>

<script>
export default {
  name: "HomeView",
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('scale-95')
      event.currentTarget.classList.toggle('shadow')
    },
  },

}
</script>

<style scoped>
</style>